import { setupProtoLogging } from '@tingdahl/tsutils/proto';
import * as proto from './proto/compiled_proto';

/**
 * Initializes the protobuf inspector/logger from @tingdahl/tsutils.
 * Enabled by default in development mode (import.meta.env.DEV),
 * unless explicitly disabled via ?proto_debug=false or localStorage.
 * Can also be dynamically enabled in production via ?proto_debug=true
 * or window.enableProtoDebug().
 */
export function initProtoInspector(): void {
  const root = (proto as any).default || proto;
  const urlParam = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('proto_debug') : null;
  const storageVal = typeof localStorage !== 'undefined' ? localStorage.getItem('proto_debug') : null;
  const explicitlyDisabled = urlParam === 'false' || storageVal === 'false';

  setupProtoLogging(root, {
    forceEnable: import.meta.env.DEV && !explicitlyDisabled,
  });

  if (typeof window !== 'undefined' && !(window as any).enableProtoDebug) {
    (window as any).enableProtoDebug = (enable: boolean = true) => {
      localStorage.setItem('proto_debug', enable ? 'true' : 'false');
      console.log(`Proto debug ${enable ? 'enabled' : 'disabled'} in localStorage. Please reload the page to apply.`);
    };
    (window as any).disableProtoDebug = () => {
      (window as any).enableProtoDebug(false);
    };
  }
}

// Automatically initialize when imported
initProtoInspector();
